import apiUrls from '../../youwell-common/apiUrls';
import ReduxStoreHelper, { DETAILS_RECIEVED, LIST_RECIEVED, UPDATED } from '../../youwell-common/ReduxStoreHelper';
import { getCurrentProgramData } from '../../common/utils/programUtils';
import { sortByString } from '../../youwell-common/arrayUtils';

const ACTION_PREFIX = 'PATIENT';

const PATIENTPROGRAM_INSERTED = 'PATIENTPROGRAM_INSERTED';
const PATIENTPROGRAM_UPDATED = 'PATIENTPROGRAM_UPDATED';
const PATIENTPROGRAM_DELETED = 'PATIENTPROGRAM_DELETED';
const PATIENT_CONNECTION_INSERTED = 'PATIENT_CONNECTION_INSERTED';
const PATIENT_CONNECTION_DELETED = 'PATIENT_CONNECTION_DELETED';
const PATIENT_NOTE_INSERTED = 'PATIENT_NOTE_INSERTED';
const PATIENT_NOTE_DELETED = 'PATIENT_NOTE_DELETED';
const PROBLEM_AREA_INSERTED = 'PROBLEM_AREA_INSERTED';
const PROBLEM_AREA_DELETED = 'PROBLEM_AREA_DELETED';
const OBSERVATION_INSERTED = 'OBSERVATION_INSERTED';
const OBSERVATIONS_LIST = 'OBSERVATIONS_LIST';
const THERAPIST_TASK_RESPOND_ADDED = 'THERAPIST_TASK_RESPOND_ADDED';
const THERAPIST_TASKS_RECEIVED = 'THERAPIST_TASKS_RECEIVED';
const THERAPIST_TASKS_DELETED = 'THERAPIST_TASKS_DELETED';
const CONTACTPERSON_UPDATED = 'CONTACTPERSON_UPDATED';
const CONTACTPERSON_INSERTED = 'CONTACTPERSON_INSERTED';
const CONTACTPERSON_DELETED = 'CONTACTPERSON_DELETED';
const PATIENTACCESSCODE_UPDATED = 'PATIENTACCESSCODE_UPDATED';
const PATIENTACCESSCODE_DELETED = 'PATIENTACCESSCODE_DELETED';
const THERAPIST_TASK_RESPONSE_INSERTED = 'THERAPIST_TASK_RESPONSE_INSERTED';
const PATIENTPROGRAM_RECIEVED = 'PATIENTPROGRAM_RECIEVED';
export const PATIENT_PROGRAM_DETAILS_RECIEVED = `${ACTION_PREFIX}/${PATIENTPROGRAM_RECIEVED}`;

const storeHelper = new ReduxStoreHelper(ACTION_PREFIX);

export const actionCreators = {
    ...storeHelper.defaultActionCreators(apiUrls.portal.patient),

    getPatientProgram: storeHelper.createGetElementActionCreator(`${apiUrls.portal.patient}/program`, PATIENTPROGRAM_RECIEVED),
    getStudentList: storeHelper.createGetListActionCreator(`${apiUrls.portal.patient}/vimolist`, LIST_RECIEVED),
    insertProblemArea: storeHelper.createInsertActionCreator(`${apiUrls.portal.patient}/sensor`, PROBLEM_AREA_INSERTED),
    deleteProblemArea: storeHelper.createDeleteActionCreator(`${apiUrls.portal.patient}/sensor`, PROBLEM_AREA_DELETED),
    getObservations: storeHelper.createGetElementActionCreator(`${apiUrls.portal.patient}/sensor`, OBSERVATIONS_LIST),
    insertObservation: storeHelper.createInsertActionCreator(`${apiUrls.portal.patient}/observation`, OBSERVATION_INSERTED),
    insertProgramForPatient: storeHelper.createInsertActionCreator(`${apiUrls.portal.patient}/programvimo`, PATIENTPROGRAM_INSERTED),
    updateProgramForPatient: storeHelper.createUpdateActionCreator(`${apiUrls.portal.patient}/program`, PATIENTPROGRAM_UPDATED),
    deleteProgramForPatient: storeHelper.createDeleteActionCreator(`${apiUrls.portal.patient}/program`, PATIENTPROGRAM_DELETED),
    insertPatientTherapist: storeHelper.createInsertActionCreator(`${apiUrls.portal.patient}/therapist`, PATIENT_CONNECTION_INSERTED),
    insertPatientNote: storeHelper.createInsertActionCreator(`${apiUrls.portal.patient}/note`, PATIENT_NOTE_INSERTED),
    deletePatientNote: storeHelper.createDeleteActionCreator(`${apiUrls.portal.patient}/note`, PATIENT_NOTE_DELETED),
    deletePatientTherapist: (data, options) => (dispatch) => {
        storeHelper.fetch(dispatch, {
            url: `${apiUrls.portal.patient}/therapist`,
            body: data,
            method: 'DELETE',
            completeAction: `${ACTION_PREFIX}/${PATIENT_CONNECTION_DELETED}`,
            options,
        });
    },
    respondNewProgramElement: storeHelper.createInsertActionCreator(`${apiUrls.portal.patient}/ttask/addresp`, THERAPIST_TASK_RESPOND_ADDED),
    insertTherapistTaskResponse: storeHelper.createInsertActionCreator(`${apiUrls.portal.patient}/ttask/resp`, THERAPIST_TASK_RESPONSE_INSERTED),
    getTherapistTasks: storeHelper.createGetListActionCreator(`${apiUrls.portal.patient}/ttask`, THERAPIST_TASKS_RECEIVED),
    deleteTherapistTask: storeHelper.createDeleteActionCreator(`${apiUrls.portal.patient}/ttask`, THERAPIST_TASKS_DELETED),
    insertContact: storeHelper.createInsertActionCreator(`${apiUrls.portal.patient}/contact`, CONTACTPERSON_INSERTED),
    updateContact: storeHelper.createUpdateActionCreator(`${apiUrls.portal.patient}/contact`, CONTACTPERSON_UPDATED),
    deleteContact: storeHelper.createDeleteActionCreator(`${apiUrls.portal.patient}/contact`, CONTACTPERSON_DELETED),
    generateNewAccessCode: (patientProgramId, options) => (dispatch) => {
        storeHelper.fetch(dispatch, {
            url: `${apiUrls.portal.patient}/program/${patientProgramId}/code`,
            method: 'PUT',
            completeAction: `${ACTION_PREFIX}/${PATIENTACCESSCODE_UPDATED}`,
            options,
        });
    },
    removeAccessCode: (patientProgramId, options) => (dispatch) => {
        storeHelper.fetch(dispatch, {
            url: `${apiUrls.portal.patient}/program/${patientProgramId}/code`,
            method: 'DELETE',
            completeAction: `${ACTION_PREFIX}/${PATIENTACCESSCODE_DELETED}`,
            options,
        });
    },
};

const initialState = {
    ...storeHelper.defaultInitialState,
};

export const reducer = (state, action) => {
    switch (action.type) {
    case `${ACTION_PREFIX}/${DETAILS_RECIEVED}`: {
        return {
            ...state,
            details: {
                ...state.details || {},
                [action.data.id]: {
                    ...action.data,
                    ...getCurrentProgramData(action.data), // should maybe check so not overwrite full patientprogram_details received in separate call..?
                },
            },
        };
    }
    case `${ACTION_PREFIX}/${PATIENTPROGRAM_RECIEVED}`: {
        const patientVm = {
            ...state.details[action.reducerParams.patientId],
            ...getCurrentProgramData({ programs: [action.data] }),
        };

        return {
            ...state,
            details: {
                ...state.details || {},
                [action.reducerParams.patientId]: patientVm,
            },
        };
    }
    case `${ACTION_PREFIX}/${UPDATED}`: {
        return {
            ...state,
            details: {
                ...state.details || {},
                [action.data.id]: {
                    ...action.data,
                    ...getCurrentProgramData(action.data),
                },
            },
            list: state.list ? state.list.map(e => (e.id === action.data.id ? action.data : e)) : null,
        };
    }
    default: {
        const stateFromDefaultActions = storeHelper.defaultReducer(state, action, initialState);

        if (stateFromDefaultActions !== null) {
            return stateFromDefaultActions;
        }
    }
    }

    switch (action.type) {
    case `${ACTION_PREFIX}/${PATIENTPROGRAM_INSERTED}`: {
        return {
            ...state,
            details: {
                ...state.details || {},
                [action.reducerParams.patientId]: {
                    ...state.details[action.reducerParams.patientId],
                    programs: [...state.details[action.reducerParams.patientId].programs || [], action.data],
                    ...getCurrentProgramData({ programs: [action.data] }),
                },
            },
            list: state.list ? state.list.map(d => (d.id === action.reducerParams.patientId ? {
                ...d,
                programs: [...d.programs || [], action.data],
            } : d)) : null,
        };
    }
    case `${ACTION_PREFIX}/${PATIENTPROGRAM_UPDATED}`: {
        return {
            ...state,
            details: {
                ...state.details || {},
                [action.reducerParams.patientId]: {
                    ...state.details[action.reducerParams.patientId],
                    programs: (state.details[action.reducerParams.patientId].programs || [])
                        .map(item => (item.id === action.data.id ? action.data : item)),
                    ...getCurrentProgramData({ programs: [action.data] }),
                },
            },
            list: state.list ? state.list.map(d => (d.id === action.reducerParams.patientId ? {
                ...d,
                programs: d.programs.map(p => (p.id === action.data.id ? action.data : p)),
            } : d)) : null,
        };
    }
    case `${ACTION_PREFIX}/${PATIENTPROGRAM_DELETED}`: {
        return {
            ...state,
            details: {
                ...state.details || {},
                [action.reducerParams.patientId]: {
                    ...state.details[action.reducerParams.patientId],
                    programs: (state.details[action.reducerParams.patientId].programs || [])
                        .filter(item => item.id !== action.data.id),
                    ...getCurrentProgramData({ programs: [] }),
                },
            },
            list: state.list ? state.list.map(d => (d.id === action.reducerParams.patientId ? {
                ...d,
                programs: d.programs.filter(p => p.id !== action.data.id),
            } : d)) : null,
        };
    }
    case `${ACTION_PREFIX}/${PATIENT_CONNECTION_INSERTED}`: {
        return {
            ...state,
            details: {
                ...state.details || {},
                [action.data.patientId]: {
                    ...state.details[action.data.patientId],
                    therapists: [...state.details[action.data.patientId].therapists || [], action.data],
                },
            },
        };
    }
    case `${ACTION_PREFIX}/${PATIENT_CONNECTION_DELETED}`: {
        return {
            ...state,
            details: {
                ...state.details || {},
                [action.inputData.patientId]: {
                    ...state.details[action.inputData.patientId],
                    therapists: (state.details[action.inputData.patientId].therapists || [])
                        .filter(item => item.therapistId !== action.inputData.therapistId),
                },
            },
        };
    }
    case `${ACTION_PREFIX}/${PATIENT_NOTE_INSERTED}`: {
        return {
            ...state,
            details: {
                ...state.details || {},
                [action.reducerParams.patientId]: {
                    ...state.details[action.reducerParams.patientId],
                    notes: [action.data, ...state.details[action.reducerParams.patientId].notes || []],
                },
            },
        };
    }
    case `${ACTION_PREFIX}/${PATIENT_NOTE_DELETED}`: {
        return {
            ...state,
            details: {
                ...state.details || {},
                [action.reducerParams.patientId]: {
                    ...state.details[action.reducerParams.patientId],
                    notes: (state.details[action.reducerParams.patientId].notes || [])
                        .filter(item => item.id !== action.data.id),
                },
            },
        };
    }
    case `${ACTION_PREFIX}/${PROBLEM_AREA_INSERTED}`: {
        return {
            ...state,
            details: {
                ...state.details || {},
                [action.reducerParams.patientId]: {
                    ...state.details[action.reducerParams.patientId],
                    sensors: [...state.details[action.reducerParams.patientId].sensors || [], action.data],
                },
            },
        };
    }
    case `${ACTION_PREFIX}/${PROBLEM_AREA_DELETED}`: {
        return {
            ...state,
            details: {
                ...state.details || {},
                [action.reducerParams.patientId]: {
                    ...state.details[action.reducerParams.patientId],
                    sensors: (state.details[action.reducerParams.patientId].sensors || []).filter(
                        item => item.id !== action.data.id,
                    ),
                },
            },
        };
    }
    case `${ACTION_PREFIX}/${OBSERVATION_INSERTED}`: {
        return {
            ...state,
            details: {
                ...state.details || {},
                [action.reducerParams.patientId]: {
                    ...state.details[action.reducerParams.patientId],
                    sensors: state.details[action.reducerParams.patientId].sensors.map(e => (e.id === action.data.sensorId
                        ? {
                            ...e,
                            observations: [...e.observations, action.data],
                        }
                        : e)),
                },
            },
        };
    }
    case `${ACTION_PREFIX}/${OBSERVATIONS_LIST}`: {
        return {
            ...state,
            details: {
                ...state.details || {},
                [action.reducerParams.patientId]: {
                    ...state.details[action.reducerParams.patientId],
                    sensors: state.details[action.reducerParams.patientId].sensors.map(e => (e.id === action.reducerParams.sensorId
                        ? {
                            ...e,
                            observations: action.data,
                        }
                        : e)),
                },
            },
        };
    }
    case `${ACTION_PREFIX}/${THERAPIST_TASKS_RECEIVED}`: {
        const { patientId } = action.reducerParams;
        const extPatientVm = state.details && state.details[patientId];

        if (!extPatientVm) {
            return state || initialState;
        }

        return {
            ...state,
            details: {
                ...state.details,
                [patientId]: {
                    ...extPatientVm,
                    therapistTasks: action.data,
                },
            },
        };
    }
    case `${ACTION_PREFIX}/${THERAPIST_TASK_RESPONSE_INSERTED}`: {
        const { patientId } = action.reducerParams;
        const { responseForm, elementCompletedDate, assignedForm } = action.data;

        const extPatientVm = (state.details && state.details[patientId]) || {};

        return {
            ...state,
            details: {
                ...state.details || {},
                [patientId]: {
                    ...extPatientVm,
                    therapistTasks: extPatientVm.therapistTasks.map(d => (d.id === responseForm.therapistProgramElementId ? {
                        ...d,
                        responseForms: [
                            ...d.responseForms || [],
                            responseForm,
                        ],
                        assignedTherapists: assignedForm
                            ? d.assignedTherapists?.map(a => (a.therapistId === assignedForm.therapistId ? assignedForm : a))
                            : d.assignedForm,
                        completedDate: elementCompletedDate,
                    } : d)),
                },
            },
        };
    }
    case `${ACTION_PREFIX}/${THERAPIST_TASK_RESPOND_ADDED}`: {
        const { newPatient, newElement, newPatientProgram } = action.data;
        const { task } = action.reducerParams;

        const patientId = action.inputData.patientId || newPatient?.id;
        const extPatientVm = state.details && state.details[patientId];

        const extList = state.list || [];
        const list = newPatient ? sortByString([...extList, newPatient]) : [...extList];
        if (!extPatientVm) {
            return {
                ...state,
                list,
            };
        }

        if (newElement && task) {
            newElement.task = task;
        }

        const programs = newPatientProgram ? [...extPatientVm.programs, newPatientProgram] : extPatientVm.programs;

        return {
            ...state,
            list,
            details: {
                ...state.details,
                [patientId]: {
                    ...extPatientVm,
                    programs,
                    therapistTasks: [...extPatientVm.therapistTasks || [], newElement],
                },
            },
        };
    }
    case `${ACTION_PREFIX}/${CONTACTPERSON_INSERTED}`: {
        return {
            ...state,
            details: {
                ...state.details || {},
                [action.reducerParams.patientId]: {
                    ...state.details[action.reducerParams.patientId],
                    contactPersons: [...state.details[action.reducerParams.patientId].contactPersons || [], action.data],
                },
            },
        };
    }
    case `${ACTION_PREFIX}/${CONTACTPERSON_UPDATED}`: {
        return {
            ...state,
            details: {
                ...state.details || {},
                [action.reducerParams.patientId]: {
                    ...state.details[action.reducerParams.patientId],
                    contactPersons: (state.details[action.reducerParams.patientId].contactPersons || [])
                        .map(item => (item.id === action.data.id ? action.data : item)),
                },
            },
        };
    }
    case `${ACTION_PREFIX}/${CONTACTPERSON_DELETED}`: {
        return {
            ...state,
            details: {
                ...state.details || {},
                [action.reducerParams.patientId]: {
                    ...state.details[action.reducerParams.patientId],
                    contactPersons: (state.details[action.reducerParams.patientId].contactPersons || [])
                        .filter(item => item.id !== action.reducerParams.contactId),
                },
            },
        };
    }
    case `${ACTION_PREFIX}/${PATIENTACCESSCODE_UPDATED}`: {
        return {
            ...state,
            details: {
                ...state.details || {},
                [action.reducerParams.patientId]: {
                    ...state.details[action.reducerParams.patientId],
                    programData: {
                        ...state.details[action.reducerParams.patientId]?.programData,
                        accessCode: action.data,
                    },
                },
            },
        };
    }
    case `${ACTION_PREFIX}/${PATIENTACCESSCODE_DELETED}`: {
        return {
            ...state,
            details: {
                ...state.details || {},
                [action.reducerParams.patientId]: {
                    ...state.details[action.reducerParams.patientId],
                    programData: {
                        ...state.details[action.reducerParams.patientId]?.programData,
                        accessCode: null,
                    },
                },
            },
        };
    }
    case `${ACTION_PREFIX}/${THERAPIST_TASKS_DELETED}`: {
        const { elementId, patientId } = action.reducerParams;

        return {
            ...state,
            details: {
                ...state.details || {},
                [patientId]: {
                    ...state.details[patientId],
                    therapistTasks: state.details[patientId].therapistTasks.filter(task => task.id !== elementId),
                },
            },
        };
    }
    default: {
        return state || initialState;
    }
    }
};
